import { Injectable } from "@angular/core";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { Observable } from "rxjs";

const STORE_NAME = "filters";

@Injectable()
export class FilterRetentionService {
  constructor(private dbService: NgxIndexedDBService) {}

  getAll() {
    return new Observable<any>((observer) => {
      this.dbService
        .getAll(STORE_NAME)
        .subscribe({
          next : (response) => observer.next(response),
          error : (e) => observer.error(e),
          complete : () => observer.complete()
        })
    });
  }


  deleteDB() {
    return new Observable<any>((observer) => {
      this.dbService
        .deleteDatabase()
        .subscribe({
          next : (response) => observer.next(response),
          error : (e) => observer.error(e),
          complete : () => observer.complete()
        })
    });
  }


  clearStore() {
    return new Observable<any>((observer) => {
      this.dbService
        .clear(STORE_NAME)
        .subscribe({
          next : (response) => observer.next(response),
          error : (e) => observer.error(e),
          complete : () => observer.complete()
        })
    });
  }


  setTabConfig(activeTab, config) {
    return new Observable<any>((observer) => {
      this.dbService
        .add(STORE_NAME, { key: activeTab, value: config })
        .subscribe({
          next : (response) => observer.next(response),
          error : (e) => observer.error(e),
          complete : () => observer.complete()
        })
    });
  }


  getTabConfig(activeTab) {
    return new Observable<any>((observer) => {
      this.dbService
        .getByIndex(STORE_NAME, "key", activeTab)
        .subscribe({
          next : (response) => observer.next(response),
          error : (e) => observer.error(e),
          complete : () => observer.complete()
        })
    });
  }


  deleteTabConfig(id) {
    return new Observable<any>((observer) => {
      this.dbService
        .delete(STORE_NAME, id)
        .subscribe({
          next : (response) => observer.next(response),
          error : (e) => observer.error(e),
          complete : () => observer.complete()
        })
    });
  }


  updateTabConfig(config) {
    return new Observable<any>((observer) => {
      this.dbService
        .update(STORE_NAME, { ...config })
        .subscribe({
          next : (response) => observer.next(response),
          error : (e) => observer.error(e),
          complete : () => observer.complete()
        })
    });
  }

}
